import { Button, Flex } from '@chakra-ui/react'
import { GCPRStatus } from '@eapproval/offer-shared'

const GCPRSubmissionActionButtons = ({
  canEditGCPRSubmission,
  canReplyGCPRInvitation,
  submissionStatus,
  onSubmit,
  onDeleteDraft,
  onResubmit,
  onArchive,
  onReply,
  canDoGCPRApproval,
  submissionContainActionRequiredApproverDetail,
  onApprove,
  onReject,
  showDeleteDraftInstead = false,
  handleOpenAddInvitationModal,
}) => {
  return (
    <Flex gap="3">
      {canEditGCPRSubmission && submissionStatus === GCPRStatus.DRAFT && (
        <>
          <Button colorScheme="green" onClick={onSubmit}>
            Submit PR
          </Button>
        </>
      )}

      {canEditGCPRSubmission && submissionStatus === GCPRStatus.REJECTED && (
        <Button colorScheme="green" onClick={onResubmit}>
          Resubmit PR
        </Button>
      )}

      {canEditGCPRSubmission &&
        [GCPRStatus.DRAFT, GCPRStatus.REJECTED].includes(submissionStatus) &&
        showDeleteDraftInstead && (
          <Button colorScheme="red" onClick={onDeleteDraft}>
            Delete Draft
          </Button>
        )}
      {canEditGCPRSubmission &&
        [GCPRStatus.DRAFT, GCPRStatus.REJECTED].includes(submissionStatus) &&
        !showDeleteDraftInstead && (
          <Button colorScheme="red" onClick={onArchive}>
            Archive
          </Button>
        )}

      {canDoGCPRApproval && submissionContainActionRequiredApproverDetail && (
        <>
          <Button colorScheme="green" onClick={onApprove}>
            Approve PR
          </Button>
          <Button colorScheme="red" onClick={onReject}>
            Reject PR
          </Button>
          <Button colorScheme="teal" onClick={handleOpenAddInvitationModal}>
            Invite
          </Button>
        </>
      )}

      {canReplyGCPRInvitation && (
        <Button colorScheme="green" onClick={onReply}>
          Reply PR
        </Button>
      )}
    </Flex>
  )
}

export default GCPRSubmissionActionButtons
